module.exports = __webpack_public_path__ + "img/mapna-d.9b2e079.webp";